import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      content: {
        margin: theme.spacing(4, 0, 0),
      },
      footer: {
        gridArea: 'footer',
        [theme.breakpoints.down('xs')]: {
          gridArea: 'middle',
          marginBottom: theme.spacing(4),
        },
      },
      middle: {
        gridArea: 'middle',
        [theme.breakpoints.down('xs')]: {
          gridArea: 'top',
        },
      },
      pautasId: {
        width: '100%',
      },
      top: {
        gridArea: 'top',
        [theme.breakpoints.down('xs')]: {
          gridArea: 'footer',
          height: '185px',
          zIndex: 1,
        },
      },
      topContent: {
        display: 'grid !important',
        gridTemplateColumns: '1fr',
        gridTemplateRows: '1fr',
        gap: '0px 0px',
        gridTemplateAreas: ` 'top' 'middle' 'footer' `,
      },
      topContentWithPlayer: {
        display: 'flex',
        flexDirection: 'column',
      },
      info: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginBottom: theme.spacing(2),
        '& > *': {
          marginBottom: theme.spacing(2),
        },
        '& h1': {
          width: '100%',
        },
        '$miniPlayer ~ &': {
          [theme.breakpoints.up('lg')]: {
            marginTop: 250,
          },
        },
        [theme.breakpoints.down('xs')]: {
          flexDirection: 'column',
        },
      },
      videos: {
        marginBottom: theme.spacing(2),
      },
      videoContainer: {
        // display: 'flex',
        // width: '100%',
        // height: '100%',
      },
      video: {
        position: 'relative',
        padding: 0,
        width: '100%',
        aspectRatio: '16 / 9',
      },
      videoDescription: {
        padding: theme.spacing(1),
        fontFamily: 'Nunito',
        fontSize: '13px',
        fontWeight: 300,
        lineHeight: '20px',
        wordBreak: 'break-all',
      },
      rowStatusPautas: {
        paddingBottom: '24px',
      },
      statusPautas: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
      },
      statusPautasIcon: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 40,
        height: 40,
        borderRadius: '50%',
        marginRight: theme.spacing(2),
      },
      statusPautaIconWarning: {
        backgroundColor: sicrediColor.warningSicrediLight,
        color: sicrediColor.warningSicrediDark,
      },
      infoCardsContainer: {
        display: 'flex',
      },
      infoCards: {
        display: 'grid',
        width: '100%',
        gridTemplateRows: 'auto',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'stretch',
        [theme.breakpoints.up('xs')]: {
          gridTemplateColumns: 'repeat(2, 1fr)',
          rowGap: '16px',
          columnGap: '16px',
        },
        [theme.breakpoints.up('sm')]: {
          gridTemplateColumns: 'repeat(2, 1fr)',
          rowGap: '32px',
          columnGap: '32px',
        },
        [theme.breakpoints.up('md')]: {
          gridTemplateColumns: 'repeat(4, 1fr)',
        },
      },
      infoCard: {
        flexShrink: 0,
      },
      radioGroup: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: '2rem',
      },
      adviceColaborador: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        '& > svg': {
          width: 32,
          height: 32,
          marginRight: theme.spacing(3),
          fill: sicrediColor.primarySicredi,
        },
        '& > p': {
          fontFamily: '"Nunito", sans-serif',
          fontSize: 16,
          fontWeight: 400,
          lineHeight: '24px',
          textAlign: 'justify',
        },
      },
      cardSlider: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: '24px',
      },
      carouselContainerDefault: {
        width: '100%',
        position: 'relative',
        paddingRight: 0,
        paddingLeft: 0,
        cursor: 'grab',
        userSelect: 'none',
      },
      carouselContainer: {
        width: '94%',
        position: 'relative',
        paddingRight: '1rem',
        paddingLeft: '2rem',
        userSelect: 'none',
      },
      carouselWrapper: {
        padding: '1.2rem 0',

        '& > .react-multiple-carousel__arrow--left': {
          left: '0px',
        },

        '& > .react-multiple-carousel__arrow--right': {
          right: '0px',
        },

        '& > button': {
          background: 'transparent!important',
          backgroundColor: 'transparent!important',
          border: '2px solid #3FA110',
          color: '#3FA110',
          minWidth: '25px',
          minHeight: '25px',
          '&:before': {
            fontSize: '14px',
            color: '#3FA110',
          },
        },
      },
      carouselButtonGroup: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'space-between',
        top: '50%',
        width: '103%',
        left: '0rem',
        zIndex: 2,

        '& > button': {
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '24px',
        },
      },
      cardDefault: {
        margin: '0px 0rem',
        marginRight: '1.5rem',
        overflow: 'hidden',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        borderRadius: '4px',
        background: '#FFFFFF',
        '& > p ': {
          margin: '1rem!important',
          color: '#595959',
        },
        '&:not(:first-child)': {
          margin: '2rem 0rem',
        },
        '& > div ': {
          marginBottom: '0px!important',
        },
        '& > div > div > div': {
          boxShadow: 'unset!important',
          borderRadius: '0px!important',
        },
      },
      card: {
        margin: '0px 1rem',
        overflow: 'hidden',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        borderRadius: '4px',
        background: '#FFFFFF',
        '& > p ': {
          margin: '1rem!important',
          color: '#595959',
        },
        '&:not(:first-child)': {
          margin: '2rem 0rem',
        },
        '& > div ': {
          marginBottom: '0px!important',
        },
        '& > div > div > div': {
          boxShadow: 'unset!important',
          borderRadius: '0px!important',
        },
      },
    }),
  { name: 'AssembleiaAssociado' }
);
